<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'customerManage-sendSample',
  components: { PageTable },
}
</script>
